import { render, staticRenderFns } from "./DuplicateAwardSource.vue?vue&type=template&id=db8bc736&scoped=true&"
import script from "./DuplicateAwardSource.vue?vue&type=script&setup=true&lang=js&"
export * from "./DuplicateAwardSource.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DuplicateAwardSource.vue?vue&type=style&index=0&id=db8bc736&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8bc736",
  null
  
)

export default component.exports